

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { chargingStationActions } from "stores/ChargingStationStore/chargingStationAction";
import { loginAction } from "stores/LoginStore/loginAction";
import { VendorActions } from "stores/VendorStore/vendorAction";

const mapStateToProps = (state) => {
  return {
    profile: state.login.userProfile,
    reqCount:state.Vendors.reqCount,
    reqChargingCount:state.chargingStation.reqChargingCount
    
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        logoutAction: loginAction.logout,
        getVendorCountAction:VendorActions.getVendorCount,
        getChargingStationCountAction:chargingStationActions.getChargingStationCount

    },
    dispatch
  );

const LayoutStore = (Container) =>
  connect(mapStateToProps,mapDispatchToProps)(Container);
export default LayoutStore;
